/**
 * Location state `organization/use` puts on the navigation it makes after login or a workspace
 * switch, so the layout can tell a landing from an ordinary visit (see useHomeLanding).
 */
export const LANDING_STATE = { landing: true } as const;

export const isLandingState = (state: unknown): boolean =>
  typeof state === 'object' && state !== null && (state as { landing?: unknown }).landing === true;
